import { useEffect, useState } from "react";
import { Plus, Pencil, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api, img, money, errMsg } from "@/lib/api";
import { totalStock } from "@/components/site/ProductCard";
import ProductEditor from "./ProductEditor";

export default function ProductsTab() {
  const [products, setProducts] = useState([]);
  const [editing, setEditing] = useState(null);
  const load = () => api.get("/admin/products").then((r) => setProducts(r.data));
  useEffect(() => { load(); }, []);

  const del = async (p) => {
    if (!window.confirm(`Delete “${p.name}”? This cannot be undone.`)) return;
    try { await api.delete(`/admin/products/${p.id}`); toast.success("Product deleted"); load(); } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div data-testid="admin-products-tab">
      <div className="flex justify-between items-center mb-6">
        <p className="text-sm text-[var(--mm-muted)]">{products.length} product{products.length === 1 ? "" : "s"}</p>
        <button data-testid="admin-add-product-button" onClick={() => setEditing({})} className="btn-mm py-3"><Plus size={14} /> Add product</button>
      </div>
      <div className="border-t border-[var(--mm-line)]">
        {products.map((p) => (
          <div key={p.id} data-testid={`admin-product-row-${p.slug}`} className="flex items-center gap-4 py-4 border-b border-[var(--mm-line)]">
            <img src={img(p.images?.[0])} alt="" className="w-14 aspect-[3/4] object-cover bg-[var(--mm-sand)]" />
            <div className="flex-1 min-w-0">
              <p className="text-sm font-semibold truncate">{p.name}</p>
              <p className="text-xs text-[var(--mm-muted)]">{p.category} · {money(p.price)} · {totalStock(p)} in stock {!p.active && "· Hidden"}{p.is_featured && " · Featured"}{p.is_new && " · New"}</p>
            </div>
            <button data-testid={`admin-edit-product-${p.slug}`} onClick={() => setEditing(p)} className="p-2 hover:text-[var(--mm-red)]" aria-label="Edit"><Pencil size={16} /></button>
            <button data-testid={`admin-delete-product-${p.slug}`} onClick={() => del(p)} className="p-2 hover:text-[var(--mm-red)]" aria-label="Delete"><Trash2 size={16} /></button>
          </div>
        ))}
      </div>
      {editing && <ProductEditor product={editing} onClose={() => setEditing(null)} onSaved={() => { setEditing(null); load(); }} />}
    </div>
  );
}
